import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import Loading from 'src/components/Loading';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { updateDistributorParams } from 'src/store/actions/distributorActions';
import DetailCard from 'src/components/DetailBox/DetailCard';
import Button from 'src/components/Button';
import EditParameterCategoryDialog from './EditParameterCategoryDetail';
import ParameterCategoryDetailInfo from './ParameterCategoryDetailInfo';

const ParameterCategoryDetail = ({ distributor, loading }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const [openEditDialog, setOpenEditDialog] = useState(false);

  const handleCloseEdit = () => {
    setOpenEditDialog(false);
  };

  const handleOpenEdit = () => {
    setOpenEditDialog(true);
  };

  const handleSubmit = useCallback(
    values => {
      dispatch(updateDistributorParams(id, values, handleCloseEdit));
    },
    [distributor, dispatch]
  );

  return (
    <DetailCard title={t('DISTRIBUTORS_VIEW.MSI_PARAMS')}>
      {loading ? (
        <Loading />
      ) : (
        <>
          <ParameterCategoryDetailInfo distributor={distributor} />
          <EditParameterCategoryDialog
            distributor={distributor}
            open={openEditDialog}
            handleClose={handleCloseEdit}
            onSubmit={handleSubmit}
          />
          <Grid container direction="column" alignItems="stretch">
            {distributor.enableMsi && (
              <Grid
                item
                sx={{
                  marginTop: '16px',
                  padding: '0 16px'
                }}
              >
                <Button onClick={handleOpenEdit}>{t('COMMON.EDIT')}</Button>
              </Grid>
            )}
          </Grid>
        </>
      )}
    </DetailCard>
  );
};

ParameterCategoryDetail.propTypes = {
  distributor: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default ParameterCategoryDetail;
